import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { fetchMe, apiFetch, logout, type SessionUser } from '../../lib/pfhApi'
import { PageShell, SectionList, Row, Note } from './SectionList'
import { planLabel, planExplainer, experienceLabel, orTapToSet } from './labels'

export function ProfilePage() {
  const navigate = useNavigate()
  const [user, setUser] = useState<SessionUser | null>(null)
  const [name, setName] = useState('')
  const [editing, setEditing] = useState(false)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    void fetchMe().then((u) => {
      setUser(u)
      setName(u?.display_name ?? '')
    })
  }, [])

  async function save() {
    setSaving(true)
    const r = await apiFetch('/auth/me/name', {
      method: 'PUT',
      body: JSON.stringify({ display_name: name }),
    })
    setSaving(false)
    if (r.ok) {
      setEditing(false)
      setUser(await fetchMe())
    }
  }

  async function doLogout() {
    await logout()
    await navigate('/login', { replace: true })
  }

  if (!user) return <PageShell title="Profile"><Row label="Loading…" /></PageShell>

  return (
    <PageShell title="Profile">
      <SectionList title="Account">
        {editing ? (
          <Row
            label="Name"
            trailing={
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                style={{
                  background: 'var(--color-bg-primary)',
                  color: 'var(--color-text-primary)',
                  border: '1px solid var(--color-bg-border)',
                  borderRadius: 8,
                  padding: '6px 10px',
                  fontSize: 15,
                }}
              />
            }
          />
        ) : (
          <Row label="Name" value={orTapToSet(user.display_name)} onClick={() => setEditing(true)} />
        )}
        <Row label="Email" value={user.email} />
        <Row label="Currency" value={orTapToSet(user.preferred_currency)} onClick={() => void navigate('/foroba/settings')} />
      </SectionList>

      <SectionList title="Plan">
        <Row label="Plan" value={planLabel(user.tier)} />
        <Row label="Experience" value={experienceLabel(user.role)} />
      </SectionList>
      <Note>{planExplainer(user.tier)}</Note>

      {editing && (
        <SectionList>
          <Row label={saving ? 'Saving…' : 'Save'} onClick={save} />
          <Row label="Cancel" onClick={() => { setEditing(false); setName(user.display_name ?? '') }} />
        </SectionList>
      )}

      <SectionList>
        <Row label="Logout" onClick={doLogout} destructive />
      </SectionList>
    </PageShell>
  )
}
